import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getClassList } from "./ClassApi";

const defaultState = {
    classList: [],
    isLoaded: false,
    isLoading: false
}
export const fetchAcademyClass = createAsyncThunk('academy_class/loadClassList', async () => {
    const classList = await getClassList();
    return classList;
});
const ClassSlice = createSlice({
    name: 'acadamyclass',
    initialState : defaultState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchAcademyClass.pending, (state) => {
                state.isLoading = true;
                state.isLoaded = false;
            })
            .addCase(fetchAcademyClass.fulfilled, (state, action) => {
                state.classList = action.payload;
                state.isLoading = false;
                state.isLoaded = true;
            })
            .addCase(fetchAcademyClass.rejected, (state) => {
                state.isLoading = false;
                state.isLoaded = false;
            });
           
    }
});
export const { setClass } = ClassSlice.actions;
export default ClassSlice.reducer;